import { useMemo } from 'react';
import { isEmpty } from 'lodash';

/**
 * Hook de capa de datos para ContactMessageMC.
 * Extrae y memoiza la información relevante de los contactos del mensaje.
 * No contiene lógica de UI ni de negocio.
 * @param {object} message - Mensaje de tipo contacto
 * @returns {object} contacts - Array de contactos normalizados
 */
export default function useContactMessageData(message) {
  // Memoiza la extracción de contactos para evitar recomputaciones
  const contacts = useMemo(() => {
    if (!message || !Array.isArray(message.contactsInformation)) return [];
    return message.contactsInformation.filter(contact => !isEmpty(contact));
  }, [message]);

  return { contacts };
}
